import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'

import type Goal from 'modules/goals/store/models/Goal'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'

class EmptyGoalForm extends Form {
  constructor(values: {}) {
    super(values, {
      id: 'string',
      owner_id: 'string',
      goal_config_id: 'string',
      progress_status: 'string',
      metadata: {},
    })
  }
}

interface Props {
  goal: Goal
  goalConfig: GoalConfig
  options: Record<string, any>
}

const Empty = ({ goal, goalConfig, options }: Props) => {
  const form = React.useRef(new EmptyGoalForm(goal.toJS())).current
  const { performAction: updateGoal } = useAsyncAction(() => form.save(goal))

  return (
    <Table.Cell colSpan={4}>
      <Select
        options={options}
        onBlur={updateGoal}
        field={form.get('progress_status')}
        readonly={goalConfig.isFinished}
      />
    </Table.Cell>
  )
}

export default observer(Empty)
